declare var $: any;

if (typeof $ !== 'undefined' && typeof $.FroalaEditor !== 'undefined') {
  $.FroalaEditor.DefineIcon('save', { NAME: 'Save', template: 'text' });
  $.FroalaEditor.RegisterCommand('save', {
    title: 'Temp Save',
    icon: 'save',
    undo: false,
    focus: false,
    callback: function() {
      this.events.trigger('custom.save');
    }
  });

  $.FroalaEditor.DefineIcon('load', { NAME: 'Load', template: 'text' });
  $.FroalaEditor.RegisterCommand('load', {
    title: 'Load',
    icon: 'load',
    // type: 'dropdown',
    undo: false,
    focus: false,
    options: {},
    callback: function(cmd) {
      this.events.trigger('custom.load');
    }
  });
}
